import { render, staticRenderFns } from "./TrainingDocumentsTable.vue?vue&type=template&id=d872f952&"
import script from "./TrainingDocumentsTable.vue?vue&type=script&lang=js&"
export * from "./TrainingDocumentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports